export default {
  Yesterday: { message: 'fulfillmentMetricsTimeFilter.Yesterday', value: 1 },
  Last7Days: { message: 'fulfillmentMetricsTimeFilter.Last7Days', value: 7 },
  Last30Days: { message: 'fulfillmentMetricsTimeFilter.Last30Days', value: 30 }
}
